module.exports = __webpack_public_path__ + "img/sys-config_d.c8096155.svg";